export enum TransactionType {
    CAMPAIGN_FEE = 'CAMPAIGN_FEE',
    ADDITIONAL_CAMPAIGN_FEE = 'ADDITIONAL_CAMPAIGN_FEE',
    MF_CHARGES = 'MF_CHARGES',
    ESTIMATED_MF_CHARGES = 'ESTIMATED_MF_CHARGES',
    ADDITIONAL_MF_CHARGES = 'ADDITIONAL_MF_CHARGES',
    ADJUSTED_MF_CHARGES = 'ADJUSTED_MF_CHARGES',
    REFUND = 'REFUND'
}
